import React from 'react';
import initialLessonBannerImage from '../assets/novas-banner-template.jpeg';

export default function LessonBanner({
  currentTab, whiteboards,
  bannerImage, docBanners, homeworkBanners, initialHomeworkBannerImage,
  studentId, isStudent, fromHomework, studentSlug,
  handleNavigationAttempt, navigate,
  saveStatus, lessonTitle, handleSave, handleBannerUploadClick,
}) {
  if (!(currentTab === 0 || (currentTab > 0 && (whiteboards[currentTab - 1]?.type === 'doc' || whiteboards[currentTab - 1]?.type === 'homework')))) {
    return null;
  }
  return (
        <div
          className="lesson-banner"
          style={{ 
            backgroundImage: `url(${
              currentTab === 0 
                ? bannerImage 
                : whiteboards[currentTab - 1]?.type === 'doc'
                ? docBanners[whiteboards[currentTab - 1]?.id] || initialLessonBannerImage
                : whiteboards[currentTab - 1]?.type === 'homework'
                ? homeworkBanners[whiteboards[currentTab - 1]?.id] || initialHomeworkBannerImage || initialLessonBannerImage
                : initialLessonBannerImage
            })` 
          }}
          onLoad={() => {
            console.log('Banner loaded for tab:', currentTab);
            console.log('Banner URL:', currentTab === 0 
              ? bannerImage 
              : whiteboards[currentTab - 1]?.type === 'doc'
              ? docBanners[whiteboards[currentTab - 1]?.id] || initialLessonBannerImage
              : whiteboards[currentTab - 1]?.type === 'homework'
              ? homeworkBanners[whiteboards[currentTab - 1]?.id] || initialHomeworkBannerImage || initialLessonBannerImage
              : initialLessonBannerImage
            );
          }}
        >
        <div className="banner-top-left-actions">
          {/* Return Button - показываем только если есть studentId */}
          {studentId && (
            <button 
              className="return-button" 
              onClick={(e) => {
                e.stopPropagation();
                // Если это студент, возвращаемся в student dashboard, иначе на страницу студента у преподавателя
                if (isStudent) {
                  const targetPath = fromHomework
                    ? `/student-dashboard/${studentSlug || studentId}?section=homework`
                    : `/student-dashboard/${studentSlug || studentId}`;
                  handleNavigationAttempt(() => navigate(targetPath));
                } else {
                  handleNavigationAttempt(() => navigate(`/students/${studentId}`));
                }
              }}
            >
              <span className="return-button-icon">
                {/* Back/Return arrow icon */}
                <svg width="12" height="12" viewBox="0 0 100 100" fill="currentColor">
                  <path d="m97.499855 59.5758209c0 14.2470169-11.5494766 25.7964935-25.7964935 25.7964935h-14.4460335c-2.3745003 0-4.2994156-1.9249115-4.2994156-4.2994156 0-2.3744965 1.9249153-4.2994156 4.2994156-4.2994156h14.2310677c9.4980011 0 17.1976624-7.6996536 17.1976624-17.1976624s-7.6996613-17.1976624-17.1976624-17.1976624h-52.9258137l13.7151318 11.5224342c1.816494 1.5315552 2.0474854 4.2456856.5159302 6.0621758-1.5315495 1.8164978-4.2456799 2.0474892-6.0621738.515934l-22.7009121-19.0464133c-1.8164933-1.5292511-2.0493481-4.2415123-.5200972-6.0580063.1581917-.1879044.3321936-.361908.5200973-.5200996l22.7009163-19.2183876c1.8283691-1.5315533 4.5521183-1.2909393 6.0836735.5374269s1.2909393 4.5521183-.5374298 6.0836735l-13.7151362 11.4364443h52.9258118c14.2465134-.1188049 25.8919067 11.3339691 26.010704 25.5804825.0008488.1006698.0010929.2013283.0007572.3019981z"/>
                </svg>
              </span>
              <span className="return-button-text">Return</span>
            </button>
          )}
          {!isStudent && (
            <>
              <button
                className={`save-lesson-button${saveStatus === 'saving' ? ' save-lesson-button--saving' : ''}`}
                data-tour="lesson-save"
                title="Save Lesson"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSave();
                }}
                disabled={!lessonTitle || !lessonTitle.trim() || saveStatus === 'saving'}
              >
                {saveStatus === 'saving' ? (
                  <span className="save-lesson-btn-spinner" aria-hidden />
                ) : (
                  <>
                    <span className="save-button-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
                      </svg>
                    </span>
                    <span className="save-button-text">Save Lesson</span>
                  </>
                )}
              </button>
              <button className="change-cover-button" onClick={handleBannerUploadClick}>
                <span className="change-cover-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                    <circle cx="12" cy="13" r="4"/>
                  </svg>
                </span>
                <span className="change-cover-text">Change Cover</span>
              </button>
              {/* Video call trigger moved to floating button on the right */}
            </>
          )}
        </div>
        {/* Homework Title Overlay - показываем только для homework табов */}
        {(currentTab > 0 && whiteboards[currentTab - 1]?.type === 'homework') && (
          <div style={{
            position: 'absolute',
            bottom: '30px',
            left: '50px',
            fontSize: '2.5rem',
            fontWeight: '700',
            fontFamily: 'Next Sphere, Arial, sans-serif',
            color: 'white',
            zIndex: 1
          }}>
            Homework
          </div>
        )}
      </div>
  );
}
